export const DEX_OP_CODES = {
  SWAP: 0x25938561,
  PROVIDE_LP: 0xfcf9e58f,
  DIRECT_ADD_LIQUIDITY: 0x4cf82803,
  REFUND_ME: 0x0bf3f447,
  RESET_GAS: 0x42a0fb43,
  COLLECT_FEES: 0x1fcb7d3d,
  BURN: 0x595f07bc,
} as const;

export const ROUTER_ADDRESS =
  "EQB3ncyBUTjZUA5EnFKR5_EnOMI9V1tTEAAPaiU71gc4TiUt";
